import React from "react";
import Navbar from "../Components/Navbar";
import Team from "../Assets/team.jpg";
import { Link } from "react-router-dom";
import licenseData from "./LicenceInput";
import Footer from "../Components/Footer";

function License() {
  return (
    <div>
      <Navbar />
      <div className="w-full text-white pb-10">
        <div className="px-4 mt-[66px] max-w-[1330px] mx-auto h-[20vh] md:h-[20vh] bg-[#024415D8] rounded-[50px]">
          <div className="flex justify-center">
            <h1 className="mt-8 mx-auto text-center text-4xl md:text-7xl font-bold">
              Partnership For Excellence
            </h1>
          </div>
        </div>

        <div className="py-16 w-full px-4 h-[100vh] lg:h-[80vh] md:h-[40vh]">
          <div className="max-w-[1240px] mx-auto grid md:grid-cols-2">
            <div className="flex flex-col justify-center">
              <h1 className="text-green-900 font-bold md:text-6xl sm:text-4xl text-3xl">
                Licensing and Accreditations
              </h1>
              <p className="p-3 text-[rgb(111,111,111)] font-bold">
                Extensive information about the brokage company's partners,
                including liquidity providers, national regulators, and
                international centers.
              </p>
              <h4 className="underline font-bold text-green-900 p-3">
                <Link to="/register" className="link">
                  Open Account
                </Link>
              </h4>
            </div>
            <img
              className="w-[600px] mx-auto my-4 rounded-[20px]"
              src={Team}
              alt="img"
            />
          </div>
        </div>

        <div className="w-full px-4">
          <div className="max-w-[1240px] mx-auto grid sm:grid-cols-2 md:grid-cols-4 gap-8">
            {licenseData.map((licenseData, id) => (
              <div
                key={id}
                className="shadow-xl flex flex-col p-2 my-4 rouded-lg text-green-100"
              >
                <h1 className="font-bold text-green-900 text-2xl">
                  {licenseData.name}
                </h1>
                <p className="p-3 text-[rgb(111,111,111)] font-bold">
                  {licenseData.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default License;
